import * as React from 'react';

import {Illustration} from 'shells/illustrations/illustration';

import {setBodyId} from '../../../dom';
import {PageContainer, PageTitleBar} from '../../../ui/layout';
import {FeatureGatePageWrapper} from '../../../ui/limits/feature-gates/feature-gate-page-wrapper';

type Props = {
    page: 'quote' | 'invoice';
};

export function QuoteAndInvoiceUpgradePageStandalone(props: Props) {
    if (props.page === 'invoice') {
        setBodyId('invoice-upgrade');
    } else {
        setBodyId('quote-upgrade');
    }

    return (
        <PageContainer
            noPadding={true}
            title='Upgrade to Nutshell Quotes & Invoices'
            whiteBackground={true}
            pageTitleBar={
                <PageTitleBar
                    title='Upgrade to Nutshell Quotes & Invoices'
                    subheaderPrimaryText='Create, send and track quotes and invoices seamlessly'
                    noMaxWidth={true}
                />
            }
        >
            <div className='background-offwhite full-height'>
                <FeatureGatePageWrapper
                    header='Upgrade for $67 / month for your entire team'
                    subHeader='Quickly create and send quotes or invoices — complete with your company’s details, product info, and pricing.'
                    bullets={[
                        'Create from a lead with one click',
                        'Share via link, email or PDF',
                        'Track views and status updates',
                        'Seamlessly move from quote to invoice',
                        'Unlimited quotes and invoices',
                    ]}
                    greyBullets={true}
                    feature='quotesAndInvoices'
                    icon={<Illustration src='quote-and-invoice-grey' />}
                    noClosingMessage={true}
                    buttonText='Add Nutshell Quotes & Invoices'
                    href='/setup/billing/add-ons'
                />
            </div>
        </PageContainer>
    );
}
